import { motion } from "framer-motion";
import TextComponent from "../components/TextComponent";
import "../styling/balcon-psa.scss";

const BalconPSA = () => {
  return (
    <motion.div
      id="balconPSA"
      initial={{ y: 0, opacity: 0 }}
      animate={{ y: 120, opacity: 1 }}
      exit={{ y: 100, opacity: 0 }}
      transition={{ duration: 1 }}
    >
      <BalconPSAPage />
    </motion.div>
  );
};

export default BalconPSA;

const balconPSAText =
  "El Balcón PSA es un espacio dedicado a la promoción y difusión de la comunidad Pinares de San Antón. Aquí podrás encontrar información sobre noticias y eventos de la comunidad.";
const balconPSAText2 =
  "Estamos trabajando en la creación de este espacio. Estará pronto disponible.";

const BalconPSAPage = () => {
  return (
    <div className="balcon-psa">
      <div className="balcon-psa-content">
        <h1>El Balcón PSA</h1>
        <div className="balcon-psa-content-text">
          <p>
            <TextComponent text={balconPSAText} />
          </p>
          <p>
            <TextComponent text={balconPSAText2} />
          </p>
        </div>
      </div>
    </div>
  );
};
